import BaseComponent from 'scripts/BaseComponent.js';

export default class WishlistTooltip extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {};

    this.dom = {
      $component: component,
    };

    this.state = {
      animationDelayDuration: 10000,
      animationDuration: 250,
      showClass: 'show',
      hiddenClass: 'hide',
    };

    this.mount();
  }

  mount() {
    super.mount();

    this.swymMount();
  }

  swymMount() {
    if (!window.SwymCallbacks) window.SwymCallbacks = [];
    window.SwymCallbacks.push(this.swymCallbackFn.bind(this));
  }

  swymCallbackFn() {
    this.startShowAnimation();
    this.initTimer();
  }

  initTimer() {
    const { state } = this;

    setTimeout(this.startHideAnimation.bind(this), state.animationDelayDuration);
  }

  startShowAnimation() {
    const { dom, state } = this;

    dom.$component.classList.add(state.showClass);
  }

  startHideAnimation() {
    const { dom, state } = this;

    dom.$component.classList.remove(state.showClass);
    setTimeout(
      () => dom.$component.classList.add(state.hiddenClass),
      state.animationDuration,
    );
  }
}
